import { PathwayItems } from '../../../components';
import { useProgram } from '../../../hooks';
import { useTranslation } from 'react-i18next';
import React from 'react';

export const ProgramViewContent = ({ programID }) => {
  const [program, programLoaded, programCourses, programCoursesLoaded] =
    useProgram({ programID });
  const descriptionContent =
    programLoaded && program?._source?.data
      ? (() => {
          try {
            const data = JSON.parse(program?._source?.data);
            return data?.description || null;
          } catch (error) {
            console.error('Error parsing program data:', error);
            return null;
          }
        })()
      : null;

  const { t } = useTranslation('library');

  return (
    <div className="pathway">
      <div className="div-block-110">
        <div className="pathway_div">
          <div className="div-block-121"></div>
          <div className="text-block-58">
            {programLoaded ? program?._source?.name : ''}
          </div>
          <div className="div-block-75">
            <div className="p_header">
              <div className="text-block-39 wide p_t wt">
                {programLoaded ? program?._source?.name : ''}
              </div>
              <div
                className="unit-wide-description people profile_description p_t wto"
                prop-data-names="stat"
                prop-data-value-stat="32 Items - 8 sections - 7 Hours"
              >
                {programCoursesLoaded
                  ? `${programCourses.length} ${' ' + t('Courses')}`
                  : ''}
              </div>
            </div>
          </div>
        </div>
        {descriptionContent && (
          <div className="p_about">
            <div className="text-block-57" prop-data-names="description">
              {descriptionContent}
            </div>
          </div>
        )}
      </div>
      <div className="p_outline">
        {programCoursesLoaded &&
          programCourses.map((data, index) => {
            if (data[index]) {
              return (
                <PathwayItems key={index} data={data[index]} index={index} />
              );
            }
          })}
      </div>
    </div>
  );
};
